module.exports = __webpack_public_path__ + "img/36827-027.12e6f4ea.jpg";